<template>
  <div class="activityDetail">
    <div class="breadcrumb">
      活动管理 > 查看详情
      <el-button class="right_f" type="primary" @click="goback">返回</el-button>
    </div>
    <div class="detail">
      <el-row>
        <el-col :span="12">
          <div class="panel">
            <span class="title">活动名称：</span>{{ activity.name }}
          </div>
          <div class="panel">
            <span class="title">活动类型：</span>{{ activity.activityType }}
          </div>
          <div class="panel">
            <span class="title activityIcon">封面图：</span>
            <img :src="activity.bigImageUrl" />
          </div>
          <div class="panel">
            <span class="title">奖品类型：</span>
            <span>{{ activity.prizeType }}</span>
          </div>
          <div class="panel">
            <span class="title">活动列表展示：</span>
            <span>{{ activity.listShow }}</span>
          </div>
          <div class="panel">
            <span class="title">活动是否开启报名：</span>
            <span>{{ activity.openJoin }}</span>
          </div>
          <div class="panel">
            <span class="title">活动参与名额:</span>
            <span>{{ activity.maxJoinCount }}</span>
          </div>
          <div class="panel">
            <span class="title">活动链接：</span>
            <span>{{ activity.clickType }}</span
            >{{ activity.activityUrl }}
          </div>
          <div class="panel" v-if="activity.smallImageUrl">
            <span class="title imgSpan">APP跑步详情处提示：</span>
            <span class="activityIcon">活动图标：</span>
            <img :src="activity.smallImageUrl" />
          </div>
          <div class="panel">
            <span class="title">中奖方式：</span>{{ activity.rewardType }}
            <span v-if="activity.rewardType!='所有奖励使用后可再次中奖'">
            {{ activity.limitCount || 0 }}次。

            </span>
          </div>
          <div class="panel">
            <span class="title">起止日期：</span
            >{{ activity.startTime }}&nbsp;至&nbsp;{{ activity.endTime }}
          </div>

          <el-form :model="activity">
            <select-school
              :schObj="activity.schObj"
              :canUse="canUse"
            ></select-school>
          </el-form>
        </el-col>
        <el-col :span="12" v-if="activity.activityType=='跑步奖励'&&activity.activityRunDetail!=null">
          <div class="panel">
            <span class="title">针对的跑步类型:</span>
            <span>{{ activity.activityRunDetail.runType }}</span>
          </div>
          <div class="panel">
            <span class="title">是否屏蔽跑步结束页广告:</span>
            <span>{{ activity.activityRunDetail.isBindEndAd }}</span>
          </div>
          <div class="panel">
            <span class="title">APP跑步结果页活动入口:</span>
            <span>{{ activity.activityRunDetail.runEndMsgType }}</span>
          </div>
          <div class="panel" v-if="activity.activityRunDetail.msgPicUrl">
            <span class="title activityIcon" >入口图片:</span>
             <img :src="activity.activityRunDetail.msgPicUrl" />
          </div>
          <div class="panel"  >
            <span class="title" >点击事件:</span>
             <span  >{{activity.activityRunDetail.clickType}}</span>
          </div>
          <div class="panel" >
            <span class="title" >点击事件url:</span>
             <span >{{activity.activityRunDetail.clickUrl}}</span>
          </div>
          <div class="panel" v-if="activity.activityRunDetail.showPopupPrompt">
            <span class="title">是否弹窗提示：</span>{{ activity.activityRunDetail.isPopup === 1 ? '是' : '否' }}
          </div>
          <div class="panel" v-if="activity.activityRunDetail.showPopupPrompt && activity.activityRunDetail.isPopup === 1">
            <span class="title">弹窗内容：</span>{{ activity.activityRunDetail.popupContent }}
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import selectSchool from "../../common/selectSch.vue";

export default {
  data() {
    return {
      canUse: false,
      activity: {
        schObj: {
          openedSchools: [],
          shieldedSchools: [],
          applicableCampus: "1",
        },
        activityRunDetail: {},
      },
    };
  },
  components: { selectSchool },
  mounted() {
    //获取活动详情
    let id = this.$util.getUrlParam("activityId");
    this.getActivityDetail(id);
  },
  methods: {
    getActivityDetail(id) {
      this.id = id;
      this.$http({
        method: "POST",
        url:
          this.$util.domain +
          "/adminapi/v2/operate/activity/queryByActivityId?activityId=" +
          this.id,
      }).then((response) => {
        if (response.data.error === 10000) {
          console.log("detail页", response.data);
          let data = response.data.data;
          data.startTime = new Date(data.startTime);
          data.endTime = new Date(data.endTime);
          data.startTime = data.startTime.format("yyyy/MM/dd");
          data.endTime = data.endTime.format("yyyy/MM/dd");
          switch (data.activityType + "") {
            case "1":
              data.activityType = "跑步奖励";
              break;
            case "2":
              data.activityType = "其他活动奖励";
              break;
            case "3":
              data.activityType = "室内锻炼奖励";
              break;
            default:
              data.activityType = "";
              break;
          }
          data.rewardType =
            data.rewardType == 1
              ? "每人每天中奖"
              : data.rewardType == 2
              ? "活动期间内每人中奖"
              : "所有奖励使用后可再次中奖";
          data.prizeType =
            data.prizeType == 1
              ? "必中奖品"
              : data.prizeType == 2
              ? "随机奖品"
              : "限量商品";
          data.listShow = data.listShow ? "展示" : "不展示";

          data.schObj = {
            openedSchools: [],
            shieldedSchools: [],
            applicableCampus: data.allUnidFlag ? data.allUnidFlag + "" : "0",
          };
          let schArray = data.activityCampusList.map((item) => {
            return { name: item.campusName, rootUnid: item.unid };
          });
          data.allUnidFlag == 0
            ? (data.schObj.shieldedSchools = schArray)
            : (data.schObj.openedSchools = schArray);

          if (data.clickType == 1) {
            data.clickType = "H5地址:";
          } else if (data.clickType == 2) {
            data.clickType = "文章ID:";
          } else if (data.clickType == 0) {
            data.clickType = "不跳转";
            data.activityUrl = "";
          } else if (data.clickType == 4) {
            data.clickType = "微信小程序-";
            // 小程序地址拆分
            let clickEvent = "";
            let wxAppId = this.$util.getUrlParam("id", data.activityUrl);
            let wxAppUrl = this.$util.getUrlParam("path", data.activityUrl);
            if (wxAppUrl) {
              clickEvent = "原始id：" + wxAppId + "， 小程序地址：" + wxAppUrl;
            } else {
              clickEvent = "原始id：" + wxAppId;
            }
            data.activityUrl = clickEvent;
          } else if (data.clickType == 5) {
            data.clickType = "音频-";
            let albumId = this.$util.getUrlParam("id", data.activityUrl),
              nickName = this.$util.getUrlParam("nickName", data.activityUrl),
              albumCount = this.$util.getUrlParam("count", data.activityUrl),
              isPaid =
                this.$util.getUrlParam("isPaid", data.activityUrl) == 1
                  ? "是"
                  : "否";

            data.activityUrl =
              "专辑id：" +
              albumId +
              "，主播名称：" +
              nickName +
              "，单曲数：" +
              albumCount +
              "，是否付费：" +
              isPaid;
          } else if (data.clickType == 7) {
            data.clickType = "支付宝小程序-";
            // 小程序地址拆分
            let clickEvent = "";
            let wxAppId = this.$util.getUrlParam("appId", data.activityUrl);
            let wxAppUrl = this.$util.getUrlParam("page", data.activityUrl);
            let query = this.$util.getUrlParam("query", data.targetUrl);
            if (wxAppUrl) {
              clickEvent = "原始id：" + wxAppId + "， 小程序地址：" + wxAppUrl;
            } else {
              clickEvent = "原始id：" + wxAppId;
            }
            if (query) {
              clickEvent = clickEvent + "，参数：" + query;
            }
            data.activityUrl = clickEvent;
          } else {
            data.clickType = "话题ID:";
          }

          if (!data.openJoin) {
            data.openJoin = "未开启";
            data.maxJoinCount = 0;
          } else {
            data.openJoin = "已开启";
          }
          /* 新增加的详情活动属性 */ 
          let temp = { 1: "计分跑", 4: "自由跑", 3: "一起跑" };
          let str = "";
         if (data.activityType!=='室内锻炼奖励'&&data.activityRunDetail!=null) {
           const rawRunClickType = data.activityRunDetail.clickType;
           data.activityRunDetail.showPopupPrompt = [1, 4, 7].indexOf(rawRunClickType) > -1;
           data.activityRunDetail.isPopup =
             data.activityRunDetail.isPopup != null ? data.activityRunDetail.isPopup * 1 : 0;
           data.activityRunDetail.popupContent = data.activityRunDetail.popupContent || "";

           data.activityRunDetail.runType = data.activityRunDetail.runType.map((item) => temp[item]).toString();
          data.activityRunDetail.isBindEndAd=data.activityRunDetail.isBindEndAd == 0 ? "否" : "是"
          data.activityRunDetail.runEndMsgType=data.activityRunDetail.runEndMsgType == 0 ? "关闭" : "开启"

          if (data.activityRunDetail.clickType == 1) {
            data.activityRunDetail.clickType = "H5地址:";
          } else if (data.activityRunDetail.clickType == 2) {
            data.activityRunDetail.clickType = "文章ID:";
          } else if (data.clickType == 0) {
            data.activityRunDetail.clickType = "不跳转";
            data.activityRunDetail.clickUrl = "";
          } else if (data.activityRunDetail.clickType == 4) {
            data.activityRunDetail.clickType = "微信小程序-";
            // 小程序地址拆分
            let clickEvent = "";
            let wxAppId = this.$util.getUrlParam(
              "id",
              data.activityRunDetail.clickUrl
            );
            let wxAppUrl = this.$util.getUrlParam(
              "path",
              data.activityRunDetail.clickUrl
            );
            if (wxAppUrl) {
              clickEvent = "原始id：" + wxAppId + "， 小程序地址：" + wxAppUrl;
            } else {
              clickEvent = "原始id：" + wxAppId;
            }
            data.activityRunDetail.clickUrl = clickEvent;
          } else if (data.activityRunDetail.clickType == 5) {
            data.activityRunDetail.clickType = "音频-";
            let albumId = this.$util.getUrlParam(
                "id",
                data.activityRunDetail.clickUrl
              ),
              nickName = this.$util.getUrlParam(
                "nickName",
                data.activityRunDetail.clickUrl
              ),
              albumCount = this.$util.getUrlParam(
                "count",
                data.activityRunDetail.clickUrl
              ),
              isPaid =
                this.$util.getUrlParam(
                  "isPaid",
                  data.activityRunDetail.clickUrl
                ) == 1
                  ? "是"
                  : "否";

            data.activityRunDetail.clickUrl =
              "专辑id：" +
              albumId +
              "，主播名称：" +
              nickName +
              "，单曲数：" +
              albumCount +
              "，是否付费：" +
              isPaid;
          } else if (data.activityRunDetail.clickType == 7) {
            data.activityRunDetail.clickType = "支付宝小程序-";
            // 小程序地址拆分
            let clickEvent = "";
            let wxAppId = this.$util.getUrlParam(
              "appId",
              data.activityRunDetail.clickUrl
            );
            let wxAppUrl = this.$util.getUrlParam(
              "page",
              data.activityRunDetail.clickUrl
            );
            let query = this.$util.getUrlParam("query", data.targetUrl);
            if (wxAppUrl) {
              clickEvent = "原始id：" + wxAppId + "， 小程序地址：" + wxAppUrl;
            } else {
              clickEvent = "原始id：" + wxAppId;
            }
            if (query) {
              clickEvent = clickEvent + "，参数：" + query;
            }
            data.activityRunDetail.clickUrl = clickEvent;
          } else {
            data.activityRunDetail.clickType = "话题ID:";
          }
         } 
          this.activity = data; 
        }
      });
    },
    goback() {
      history.back();
    },
  },
};
</script>

<style>
.activityDetail {
  height: 100%;
}

.activityDetail .detail {
  margin-left: 20px;
  padding-bottom: 30px;
  overflow: hidden;
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
}

.activityDetail .title {
  display: inline-block;
  width: 180px;
  
  text-align: right;
}

.activityIcon {
  position: relative;
  top: -70px;
}

.activityItem {
  height: 40px;
}

.activityDetail .imgSpan {
  position: relative;
  top: -70px;
}

.activityDetail .panel {
  height: 80px;
}

.activityDetail img {
  display: inline-block;
  width: 150px;
  height: 80px;
}
</style>


// WEBPACK FOOTER //
// activityDetail.vue?dbd04f98